import React, { useState } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import Time from 'react-time';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

function VcamsDialog (props) {
  const { dlgType = '', infraList = [], uuid, clients = [] } = props;
  const [ewcName, setEwcName] = useState(props.ewc_instance_name || '');
  //VEP-2142
  //const [type, setType] = useState(props.type || 'public');
  const [okClicked, setOkClicked] = useState(false);

  function isDeployDisabled () {
    const isNameEmpty = !(ewcName !== undefined && ewcName !== '');
    const isEqual = props.ewc_instance_name !== undefined && props.ewc_instance_name === ewcName;
    return isNameEmpty || isEqual || okClicked;
  }

  //VEP-2142
  /*function isTypeDisabled () {
    return (props.type === type) || okClicked;
  }*/

  function onDeploy () {
    setOkClicked(true);
    props.onOk(ewcName, uuid);
  }

  //VEP-2142
  /*function onChangeType () {
    setOkClicked(true);
    props.onOk(type, uuid);
  }*/

  function onRestart () {
    setOkClicked(true);
    props.onOk(uuid);
  }

  function actionByType () {
    if (dlgType === 'deploy') {
      return (
        <Button variant='contained' color='primary' disabled={isDeployDisabled()} onClick={onDeploy}>Deploy</Button>
      );
    } /* VEP 2142 else if (dlgType === 'changeType') {
      return (
        <Button variant='contained' color='primary' disabled={isTypeDisabled()} onClick={onChangeType}>Set Type</Button>
      );
    }*/ else if (dlgType === 'restart') {
      return (
        <Button variant='contained' color='primary' disabled={okClicked} onClick={onRestart}>Ok</Button>
      );
    }
  }

  function contentByType () {
    if (dlgType === 'deploy') {
      return (
        <>
          <Typography>A VCAM can be deployed only to a paired EWC</Typography>
          <TextField select required label='Select a EWC' value={ewcName} onChange={e => setEwcName(e.target.value)}>
            {
              infraList.map(({ name = '' }, idx) => (
                <MenuItem key={idx} value={name}>{name}</MenuItem>
              ))
            }
          </TextField>
        </>
      );
    } /*else if (dlgType === 'changeType') {
      return (
        <TextField select required label='Select a type' value={type} onChange={e => setType(e.target.value)}>
          {
            ['public', 'private'].map((item, idx) => (
              <MenuItem key={idx} value={item}>{item}</MenuItem>
            ))
          }
        </TextField>
      );
    } */else if (dlgType === 'restart') {
      return uuid ? <Typography>{`Do you want to restart VCAM(${uuid})`}</Typography> : <Typography>Do you want to restart selected VCAM</Typography>;
    } else if (dlgType === 'clientInfo') {
      return (
        <Table>
          <TableHead>
            <TableRow>
              {
                ['IP Address', 'Mode', 'Port', 'Connection Time'].map(th => <TableCell key={th} style={{ paddingTop: 8, paddingBottom: 8 }}>{th}</TableCell>)
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {
              clients.map((td, idx) => (
                <TableRow key={idx}>
                  <TableCell style={{ paddingTop: 8, paddingBottom: 8 }}>{td.ip_addr || '-'}</TableCell>
                  <TableCell style={{ paddingTop: 8, paddingBottom: 8 }}>{td.mode || '-'}</TableCell>
                  <TableCell style={{ paddingTop: 8, paddingBottom: 8 }}>{td.port || '-'}</TableCell>
                  <TableCell style={{ paddingTop: 8, paddingBottom: 8 }}>
                    {
                      td.connectionTime
                        ? (<Time value={td.connectionTime * 1000} format='YYYY-MM-DD HH:mm' />)
                        : '-'
                    }
                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      );
    }
  }

  function titleByType () {
    if (dlgType === 'deploy') {
      return 'Deploy VCAM';
    } else if (dlgType === 'changeType') {
      return 'Change VCAM Type';
    } else if (dlgType === 'restart') {
      return 'Restart VCAM';
    } else if (dlgType === 'clientInfo') {
      return `${pluralize('Client', clients.length)} Details`;
    }
  }

  function maxWidth () {
    if (dlgType === 'clientInfo') {
      return 'sm';
    } else {
      return 'xs';
    }
  }

  return (
    <Dialog
      open={props.open}
      maxWidth={maxWidth()}
      fullWidth
    >
      <DialogTitle>{titleByType()}</DialogTitle>
      <DialogContent>{contentByType()}</DialogContent>
      <DialogActions>
        <Button variant='contained' disabled={okClicked} onClick={props.onCancel}>Cancel</Button>
        {actionByType()}
      </DialogActions>
    </Dialog>
  );
}

VcamsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  dlgType: PropTypes.string,
  infraList: PropTypes.array,
  uuid: PropTypes.string,
  type: PropTypes.string,
  ewc_instance_name: PropTypes.string,
  clients: PropTypes.arrayOf(PropTypes.object)
};

export default React.memo(VcamsDialog);
